import { Component, OnInit, Input } from '@angular/core';
import { ConfigService } from '../../../services/config/config.service';
import { GridService } from '../../../services/grid/grid.service';

/**
 * Creates the widget styling for the header/footer of each dialog box
 */
@Component({
  selector: 'app-widget-container',
  templateUrl: './widget-container.component.html',
  styleUrls: ['./widget-container.component.scss']
})
export class WidgetContainerComponent implements OnInit {
  @Input()
  public widgetIcon: string;

  @Input()
  public widgetTitle: string;

  constructor(private config: ConfigService, private grid: GridService) { }

  ngOnInit() {}

  /**
   * Allows the X button on each of the widgets to close them
   */
  public closeWidget() {
    let widgetFound = false;
    for (const [i, tool] of this.config.tools.entries()) {
      if (tool.name === this.widgetTitle) {
        this.config.tools[i].grid = false;
        this.config.tools[i].status = 'widget-off';
        this.grid.widgetOff(tool.id);
        widgetFound = true;
      }
    }

    if (!widgetFound) {
      this.grid.widgetOff(this.widgetTitle.toLowerCase());
      // If widget not found, Check to see if the widget is in the nonToolbarWidgets array. These are widgets
      //  that are used in the app but are called from another widget and not on the toolbar.
      if (this.config.nonToolbarWidgets && this.config.nonToolbarWidgets.length > 0) {
        const widgetObj = this.config.nonToolbarWidgets.filter(obj => {
          return obj.name === this.widgetTitle
        });
        if (widgetObj && widgetObj.length > 0 && widgetObj[0].id) {
          //console.log('turn of: ' +  widgetObj[0].id);
          this.grid.widgetOff(widgetObj[0].id);
        } 
      }
    }
  }

}
